import {
    ContentImage,
    ContentText,
} from '@/components/molecules/PremiumOverview'
import bgImg from '/assets/premium-overview-header-bg.png'
import fgImg from '/assets/premium-overview-header-avatar.png'
import { useTranslation } from 'react-i18next'
import { Icon } from '@/components/atoms'
import { FormattedI18nString } from '@/utils/FormattedI18nString'

export const Header: React.FC = () => {
    const { t } = useTranslation('translations')

    return (
        <div
            className="mt-12 grid grid-cols-1 items-center gap-12 lg:mt-0 lg:grid-cols-2"
            data-testid="premium-overview-header"
        >
            <div className="flex h-full w-full justify-start lg:justify-center">
                <ContentText
                    className="pl-6 lg:ml-auto"
                    title={t('sustainability.premiumOverview.header.title')}
                    subtitle={t(
                        'sustainability.premiumOverview.header.subtitle'
                    )}
                    list={[
                        {
                            icon: <Icon name="check" />,
                            text: (
                                <FormattedI18nString i18nKey="sustainability.premiumOverview.header.firstListItem" />
                            ),
                        },
                        {
                            icon: <Icon name="check" />,
                            text: (
                                <FormattedI18nString i18nKey="sustainability.premiumOverview.header.secondListItem" />
                            ),
                        },
                        {
                            icon: <Icon name="check" />,
                            text: (
                                <FormattedI18nString i18nKey="sustainability.premiumOverview.header.thirdListItem" />
                            ),
                        },
                    ]}
                    footer={
                        <>
                            <span className="text-body-medium">
                                <FormattedI18nString i18nKey="sustainability.premiumOverview.header.contact" />
                            </span>
                            <a
                                href="mailto:contact@myenergynetwork.com"
                                className="font-semibold text-blue-500"
                            >
                                {t(
                                    'sustainability.premiumOverview.footer.email'
                                )}
                            </a>
                            .
                        </>
                    }
                />
            </div>
            <ContentImage
                bgSrc={bgImg}
                fgSrc={fgImg}
                className="h-auto max-h-[320px] px-16"
            />
        </div>
    )
}
